import { render, staticRenderFns } from "./EmployeesView.vue?vue&type=template&id=ce45c4d6&scoped=true"
import script from "./EmployeesView.vue?vue&type=script&lang=js"
export * from "./EmployeesView.vue?vue&type=script&lang=js"
import style0 from "./EmployeesView.vue?vue&type=style&index=0&id=ce45c4d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce45c4d6",
  null
  
)

export default component.exports